import { render, staticRenderFns } from "./StepUpload.vue?vue&type=template&id=afe29146&scoped=true&"
import script from "./StepUpload.vue?vue&type=script&setup=true&lang=ts&"
export * from "./StepUpload.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe29146",
  null
  
)

export default component.exports